<template>
  <div class="px-5 py-1 pb-5 border border-gray-400 border-solid my-2">
    <h2 class="mt-5 mb-1 text-xl text-left text-black font-bold">
      Información de la solicitud
    </h2>
    <p class="text-left">
      Ingrese la información necesaria para realizar la gestión de la solicitud
    </p>

    <div class="container mx-auto max-w-4xl px-4 mt-5">
      <DetailCardHead
        labelLeft="Tipo de problema"
        labelRight="Estado"
        :actionLeft="defineReturnActionLeft()"
        :actionRight="defineReturnActionRight()"
        :status="status"
      />

      <div class="flex flex-row gap-2">
        <div class="w-full grid grid-cols-2 gap-2">
          <BaseInput
            type="text"
            label="Nombres"
            v-model="form.first_name"
            placeholder=""
            :disabled="true"
            :required="true"
          />
          <BaseInput
            type="text"
            label="Apellidos"
            v-model="form.last_name"
            placeholder=""
            :disabled="true"
            :required="true"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2">
        <div class="w-full grid grid-cols-2 gap-2">
          <BaseInput
            type="text"
            label="Tipo de identificación"
            v-model="form.identification_type_name"
            placeholder=""
            :disabled="true"
            :required="true"
          />
          <BaseInput
            type="text"
            label="Número de identificación"
            v-model="form.identification_number"
            placeholder=""
            :disabled="true"
            :required="true"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2">
        <div class="w-full grid grid-cols-2 gap-2">
          <BaseInput
            type="text"
            label="Número de teléfono"
            v-model="form.phone"
            placeholder=""
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Correo electrónico"
            v-model="form.email"
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>
      <div class="flex flex-row gap-2">
        <div class="w-full grid grid-cols-2 gap-2">
          <BaseInput
            v-if="form.type_problem === 'email'"
            type="text"
            label="Nuevo correo electrónico"
            v-model="form.new_email"
            placeholder=""
            :disabled="true"
          />
          <BaseInput
            v-if="form.type_problem === 'identification'"
            type="text"
            label="Nuevo número de identificación"
            v-model="form.new_identification_number"
            placeholder=""
            :disabled="true"
          />
          <BaseInput
            type="text"
            label="Fecha de recepción de solicitud"
            v-model="form.creation_date"
            placeholder=""
            :disabled="true"
          />
        </div>
      </div>

      <h3 class="mt-5 mb-1 text-lg text-left text-black font-bold">
        Soporte de documento de identidad
      </h3>
      <div class="flex flex-row gap-2 align-items-center w-6/12 my-3">
        <LabelButtonModal
          label="Soporte de documento de identidad"
          :value="form.document_file_name"
          :url_download="downloadUrl"
          :typeMime="typeMime"
        />
      </div>

      <div v-if="defineReturnActionRight() === 'Cerrada'">
        <h3 class="mt-5 text-lg text-left font-bold text-black">
          Gestor de la solicitud
        </h3>
        <div class="flex flex-row gap-2">
          <div class="w-full grid grid-cols-2 gap-2">
            <BaseInput
              type="text"
              label="Nombre completo del gestor"
              v-model="form.manager_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Correo electrónico del gestor"
              v-model="form.manager_email"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Tipo de identificación"
              v-model="form.manager_identification_type_name"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Número de identificación"
              v-model="form.manager_identification_number"
              placeholder=""
              :disabled="true"
              :required="true"
            />
            <BaseInput
              type="text"
              label="Fecha de gestión de solicitud"
              v-model="form.management_date"
              placeholder=""
              :disabled="true"
              :required="true"
            />
          </div>
        </div>
      </div>

      <h3 class="mt-5 text-lg text-left font-bold text-black">
        Gestión de la solicitud
      </h3>
      <div class="flex flex-row gap-2 align-items-center w-full">
        <BaseTextarea
          type="textarea"
          label="Observaciones"
          v-model="form.observations"
          :disabled="defineReturnActionRight() === 'Abierta' ? false : true"
        />
      </div>

      <div class="flex flex-row flex-direction-col">
        <BaseRadio
          label="Decisión sobre la solicitud"
          :radioOptions="optionsAboutRequest"
          name="makeDesition"
          :disabled="defineReturnActionRight() === 'Abierta' ? false : true"
          direction="column"
          numRows="2"
          v-model="selectedAboutRequest"
        />
      </div>

      <div
        v-if="defineReturnActionRight() === 'Abierta' ? true : false"
        class="w-full my-6"
      >
        <p v-if="form.type_problem === 'email'" class="text-left">
          La decisión de la solicitud será notificada al usuario mediante el
          correo electronico: {{ this.form.new_email }}
        </p>
        <p v-if="form.type_problem === 'identification'" class="text-left">
          La decisión de la solicitud será notificada al usuario mediante el
          correo electronico: {{ this.form.email }}
        </p>
      </div>

      <div v-if="feedback">
        <p class="mt-2 mb-4 text-sm text-center text-red-500">
          {{ feedback }}
        </p>
      </div>

      <div
        v-if="defineReturnActionRight() === 'Abierta' ? true : false"
        class="w-full flex justify-end self-end gap-4"
      >
        <a-button
          class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
          type="danger"
          ghost
          shape="round"
          @click="returnTechnicalSupport"
        >
          Cancelar
        </a-button>

        <!-- :disabled="disableButton && disabled" -->
        <!-- :loading="(searching = loading)" -->
        <a-button
          @click="saveTechnicalSupport"
          type="primary"
          shape="round"
          class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
        >
          Guardar
        </a-button>
      </div>

      <div
        v-if="defineReturnActionRight() === 'Cerrada' ? true : false"
        class="w-full flex justify-end self-end gap-4"
      >
        <a-button
          @click="returnTechnicalSupport"
          type="primary"
          shape="round"
          class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
        >
          Regresar
        </a-button>
      </div>
    </div>

    <Modal v-if="viewModal" size="md">
      <div class="text-justify">
        <h3 class="text-blue-700 text-2xl mt-2 mb-4">
          Solicitud de soporte técnico
        </h3>
        <p class="mt-4">{{ msgToModal }}</p>
      </div>
      <div class="text-center">
        <button
          @click="returnTechnicalSupport"
          class="mt-4 py-2 px-4 bg-blue-500 text-white rounded-lg"
        >
          ACEPTAR
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import BaseDownload from "../../../../components/UI/BaseInput/BaseDownload.vue";
import LabelButtonModal from "../../../../components/UI/BaseInput/LabelButtonModal.vue";
import DetailCardHead from "../../../../components/UI/DetailCardHead.vue";
import supportServiceImplementation from "@/feature/tecnical_support/data/services/tecnical_support_services_impl";

export default {
  components: { BaseDownload, DetailCardHead, LabelButtonModal },
  data() {
    return {
      isLoading: true,
      isOpen: false,
      status: "text-yellow-300",
      legend: "Descargar",
      form: {
        id: "",
        status: "",
        identification_type_name: "",
        name: "",
        type_problem_name: "",
        document_file_name: "",
        identification_number: "",
        phone: "",
        email: "",
        new_identification_number: "",
        new_email: "",
        check_personal_data: "",
        check_sensitive_data: "",
        first_name: "",
        last_name: "",
        type_problem: "",
        creation_date: "",
        observations: "",
        accepted: "",
        accepted_cod: "",
        manager_identification_number: "",
        management_date: "",
        identification_type: "",
        status_cod: "",
        typeMime: "",
        manager_identification_type: "",
      },
      msgToModal: "",
      optionsAboutRequest: [
        { id: 1, name: "Aceptada" },
        { id: 2, name: "Rechazada" },
      ],
      valuesStatus: [
        { value: "Abierta", color: "text-yellow-300" },
        { value: "Cerrada", color: "text-green-500" },
      ],

      downloadUrl: "",
      typeMime: "",
      feedback: "",
      selectedAboutRequest: null,
      separator: "_id_storage__SFC",
      viewModal: false,
    };
  },
  mounted() {
    supportServiceImplementation
      .getTecnicalSupportDetail(this.$route.params.id)
      .then(({ data }) => {
        this.form = data.data;
        this.form.creation_date = this.form.creation_date.replace("T", " ");

        if (this.form.accepted !== null) {
          this.selectedAboutRequest = this.form.accepted ? 1 : 2;
        }

        if (this.form.management_date && this.form.management_date !== null) {
          this.form.management_date = this.form.management_date.replace(
            "T",
            " "
          );
        }

        this.technicalSupportId = this.$route.params.id;
      });

    supportServiceImplementation
      .getTecnicalSupportFile(this.$route.params.id)
      .then(({ data }) => {
        this.downloadUrl = data.data.url;
        this.typeMime = data.data.mimeType;
      });
  },
  methods: {
    checkForm() {
      let valid = false;
      if (this.selectedAboutRequest === null) {
        this.feedback =
          "Debe seleccionar una opción para la decisión de la solicitud de soporte";
        return valid;
      }

      this.feedback = "";
      valid = true;
      return valid;
    },
    defineReturnActionLeft() {
      return this.form.type_problem_name;
    },
    defineReturnActionRight() {
      this.valuesStatus.filter((item) => {
        if (item.value === this.form.status) {
          this.status = item.color;
        }
      });
      return this.form.status;
    },
    returnTechnicalSupport() {
      this.$router.push(`/dashboard/users/technical-support`);
    },
    saveTechnicalSupport() {
      if (this.checkForm()) {
        const dataTechnicalSupport = {
          observations: this.form.observations,
          accepted: this.selectedAboutRequest === 1 ? true : false,
          status_cod: 2,
        };

        supportServiceImplementation
          .updateTechnicalSupport(this.technicalSupportId, dataTechnicalSupport)
          .then(({ data }) => {
            if (data) {
              if (data?.status_code === 400) {
                if (data?.error) {
                  this.msgToModal = `Solicitud de soporte rechazada: ${data?.error}`;
                  this.viewModal = true;
                  return;
                }
                this.msgToModal =
                  "Error al gestionar la solicitud de soporte técnico";
                this.viewModal = true;
                return;
              }
              if (data?.status_code === 404) {
                this.msgToModal =
                  "Error al gestionar la solicitud de soporte técnico";
                this.viewModal = true;
                return;
              }
              this.msgToModal =
                "La solicitud de soporte técnico se ha gestionado correctamente";
              this.viewModal = true;
              return;
            }

            this.msgToModal =
              "Error al gestionar la solicitud de soporte técnico";
            this.viewModal = true;
            return;
          })
          .catch(() => {
            this.msgToModal = "Error al actualizar soporte técnico";
            this.viewModal = true;
            return;
          });
      }
    },
  },
  watch: {
    selectedAboutRequest(newVal) {
      if (newVal !== null) {
        this.feedback = "";
      }
    },
  },
};
</script>

<style></style>
